export default "__VITE_ASSET__ca026e77__"